'use client'
import { getUniqueDeviceId } from "@/helpers/Functions/TopLevel";
import { createContext, useContext, useEffect, useState } from "react";

interface UserContextType {
    signedIn: boolean;
    mychaivio: boolean;
    setSignedIn: React.Dispatch<React.SetStateAction<boolean>>;
    email: string;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};

interface UserProviderProps {
    children: React.ReactNode;
    ismychaivio?: boolean;
    loggedIn: boolean;
    mail: string;
}


export const UserProvider: React.FC<UserProviderProps> = ({ children, loggedIn, ismychaivio = false, mail }) => {
    const [signedIn, setSignedIn] = useState<boolean>(loggedIn);
    const [mychaivio, setmychaivio] = useState<boolean>(ismychaivio);
    const [email, setEmail] = useState<string>(mail);
    useEffect(() => {
        if (mychaivio && !signedIn) {
            setmychaivio(false)
            email && setEmail('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signedIn])
    return (
        <UserContext.Provider value={{ signedIn, setSignedIn, mychaivio, email }}>
            {children}
        </UserContext.Provider>
    );
};